<template>
	<v-container grid-list-xl>
		<v-form v-model="isAddValid">
			<v-layout row wrap>
				<v-flex lg6>
					<v-switch label="Active" v-model="roleActive"></v-switch>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">* Role Name:</label>
					<v-text-field label="Name" v-model="roleName" required :rules="nameRules" single-line solo></v-text-field>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">* Role Description:</label>
					<v-text-field label="Description" v-model="roleDescription" required :rules="descriptionRules" single-line solo></v-text-field>
				</v-flex>
				<!--<v-flex lg6>
					<label class="blackLabel">* Role Level:</label>
					<v-text-field label="Level" v-model="roleLevel" required :rules="levelRules" single-line solo></v-text-field>
				</v-flex>-->
				<v-flex lg6>
					<label class="blackLabel">* Role User Type:</label>
					<v-select :items="userType" label="User Type" class="dropdown" required :rules="userRules" v-model="roleUserType" item-value="id" single-line solo></v-select>
				</v-flex>
        <v-flex lg6 v-show="roleUserType == '1'">
          <label class="blackLabel">* Is Role Commercial Role:</label>
          <v-switch v-model="roleCommercialKam"></v-switch>
        </v-flex>
        <!--<v-flex lg6>
          <label class="blackLabel">* Is Role Commercial Originator Role:</label>
          <v-switch v-model="roleCommercialOriginator"></v-switch>
        </v-flex>-->
				<div class="pl-4 pr-1 pb-4 buttonHolder">
					<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncAddRole()">Save</v-btn>
                        <small>* The button will activate once all required fields have been completed</small>
					</div>
				</div>
			</v-layout>
		</v-form>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex';
	export default {
	  name: 'Settings',
	  data () {
			return {
				isAddValid: false,
				roleActive: false,
				roleName: '',
				roleDescription: '',
				roleLevel: '',
				roleUserType: '',
        roleCommercialKam: false,
        roleCommercialOriginator: false,
				userType: [
					{ id: '1', text: 'Manufacturer User' },
					{ id: '2', text: 'Customer User' },
					{ id: '3', text: 'Specifier User' },
					{ id: '4', text: 'Public User' },
                    { id: '5', text: 'Non-registered User' },
                    { id: '6', text: 'Vendor User' }
				],
				nameRules: [
					v => !!v || 'Role name is required',
				],
				descriptionRules: [
					v => !!v || 'Role description is required',
				],
				levelRules: [
					v => !!v || 'Role level is required',
				],
				userRules: [
					v => !!v || 'Role user type is required',
				]
			};
		},
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
			fncAddRole() {
				this.$store.dispatch({
					type: 'fncAddRole',
					roleDetails: {
						roleActive: this.roleActive,
						roleName: this.roleName,
						roleDescription: this.roleDescription,
						roleLevel: this.roleLevel,
						roleUserType: this.roleUserType,
            roleCommercialKam: this.roleCommercialKam,
            roleCommercialKam: this.roleCommercialKam
					}
				});
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'runAdd'
			])
		},
        watch: {
            runAdd() {
                console.log( this.runAdd );
                if( this.runAdd === false ) {
                    this.isAddValid = false;
                    this.roleActive = '';
                    this.roleName = '';
                    this.roleDescription = '';
                    this.roleLevel = '';
                    this.roleUserType = '';
                }
            }
        }
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>
